import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { SMS_MODULE_URL } from '@shared/helpers/env';

class SenderServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect() {
    return this.http.get('/select');
  }

  deactivate(id) {
    return this.http.post(`/${id}/deactivate`);
  }
}

export const SenderService = new SenderServiceClass({
  base_url: SMS_MODULE_URL,
  api_version: 1,
  resource: 'senders'
});
